import { action, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';
import { RouteService } from '../services/RouteService';

import { ILanguageStore } from './LanguageStore';
import { Loadable } from './models/Loadable';
import { PublicLinkInvoiceBalance } from './models/PublicLinkInvoiceBalance';
import { IRouteStore } from './RouteStore';

export class DirectPaymentStore {
  @observable
  public balance: Loadable<PublicLinkInvoiceBalance> = new Loadable<PublicLinkInvoiceBalance>();

  constructor(
    private routeStore: IRouteStore,
    private languageStore: ILanguageStore,
    private apiService: ApiService,
    private routeService: RouteService
  ) {
    makeObservable(this);
  }

  @action
  public tryLoadBalance(): void {
    const mac = this.routeStore.queryParam('mac');
    const invoiceId = this.routeStore.queryParam('invoiceId');
    const refNumber = this.refNumber;
    const source = this.routeStore.queryParam('source');
    const bankCode = this.bankCode;

    this.balance = Loadable.toLoadable(this.apiService.getBalance(mac, invoiceId, refNumber, source, bankCode));
  }

  public get hasUnsettledInvoices(): boolean {
    return this.amountToPay > 0;
  }

  public get amountToPay(): number {
    return -1 * this.balance.payload.balance;
  }

  public get refNumber(): string {
    return this.routeStore.queryParam('refNumber');
  }

  public get bankCode(): string {
    return this.routeStore.queryParam('bankCode');
  }

  public get successUrl(): string {
    return this.routeService.createAbsoluteUrl('/arved/otsemakse/teostatud');
  }

  public get failedUrl(): string {
    return this.routeService.createAbsoluteUrl('/arved/otsemakse/tuhistatud');
  }

  public get processingUrl(): string {
    return this.routeService.createAbsoluteUrl('/arved/otsemakse/tootlemisel');
  }
}
